<script>
import CustomTooltip from '@/components/booking/bookingList/custom-tooltip.vue'

export default {
  name: 'BookingViewToggleOption',
  components: { CustomTooltip },
  props: {
    showDayByDayBlock: { type: Boolean, default: false },
  },
}
</script>

<template>
  <div>
    <CustomTooltip position="bottom" :text="this.$t('booking.blockLabel')">
      <v-icon
        data-block-view="block"
        :class="['block-booking-filter', !showDayByDayBlock && 'active']"
        @click="$emit('toggle', 0)"
      >
        mdi-calendar-month-outline
      </v-icon>
    </CustomTooltip>

    <CustomTooltip position="bottom" :text="$t('customeToolTip.dayByDay')">
      <v-icon
        data-block-view="day-by-day"
        :class="['day-by-day-filter', showDayByDayBlock && 'active']"
        @click="$emit('toggle', 1)"
      >
        mdi-calendar-today-outline
      </v-icon>
    </CustomTooltip>
  </div>
</template>
